// ABOUTME: Returns a referentially stable function that always invokes the latest callback passed in.
// ABOUTME: Lets a memoized child skip re-renders while the parent keeps passing fresh closures.
import { useCallback, useRef } from 'react';

export function useStableCallback<Args extends unknown[], Result>(
    callback: (...args: Args) => Result,
): (...args: Args) => Result {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    return useCallback((...args: Args) => callbackRef.current(...args), []);
}
